// bao migrate skip

import TabPage from "./../factories/tab-page";
import "./tabs/book-hours-detail";
import "./../services/bao-menu";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-tabs";
import "./../bindings/bao-searcher";
import "./../bindings/bao-number-box";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import TabController from "./../factories/tab-controller";
import * as moment from "moment";
import BaseViewModel from "./../factories/base-view-model";
import BookHoursDetailViewModel from "./../view-models/tabs/book-hours-detail";

class BookHoursViewModel extends BaseViewModel {
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.TabPage = tabPage;
        //subscribes
        this.IllDay.subscribe(() => {
            this.CalculateDayToHour(this.IllDay, this.IllHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.IllHourJs.subscribe(() => {
            this.CalculateHourToDay(this.IllDay, this.IllHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.HolidayDay.subscribe(() => {
            this.CalculateDayToHour(this.HolidayDay, this.HolidayHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.HolidayHourJs.subscribe(() => {
            this.CalculateHourToDay(this.HolidayDay, this.HolidayHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.SpecialHolidayPaidDay.subscribe(() => {
            this.CalculateDayToHour(this.SpecialHolidayPaidDay, this.SpecialHolidayPaidHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.SpecialHolidayPaidHourJs.subscribe(() => {
            this.CalculateHourToDay(this.SpecialHolidayPaidDay, this.SpecialHolidayPaidHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.SpecialHolidayUnpaidDay.subscribe(() => {
            this.CalculateDayToHour(this.SpecialHolidayUnpaidDay, this.SpecialHolidayUnpaidHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.SpecialHolidayUnpaidHourJs.subscribe(() => {
            this.CalculateHourToDay(this.SpecialHolidayUnpaidDay, this.SpecialHolidayUnpaidHourJs);
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        });
        this.SelectedPerson.subscribe((item) => {
            this.ChangeObject(0, item.ConfigurationItemId);
        });
        this.DateJs.subscribe((item) => {
            this.ChangeObject(0, this.ConfigurationItemId());
        });
    }
    private _initializing: boolean = true;
    private _calculating: boolean = false;
    TabPage: TabPage;
    Bao = Bao;
    TabViewModel = new TabController(false);
    PrimaryKey = "ConfigurationItem100ActivityId";
    RefreshUrl = "BookHours/Get";
    SaveUrl = "BookHours/Save";
    DeleteUrl = "BookHours/Delete";
    IsInUseUrl = "BookHours/IsInUse";
    PermissionSave = "ConfigurationItem100ActivitySave";
    PermissionRefresh = "ConfigurationItem100ActivityRefresh";
    PermissionDelete = "ConfigurationItem100ActivityDelete";
    //observables
    OpenData = ko.observable<any>();
    SaveAllowed = ko.observable<boolean>(false);
    SessionTabId = ko.observable<string>();
    ConfigurationItem100ActivityId = ko.observable<string>();
    DateJs = ko.observable<string>();
    Break1Js = ko.observable<string>();
    Break2Js = ko.observable<string>();
    Break3Js = ko.observable<string>();
    IsWeekend = ko.observable<boolean>();
    IsPublicHoliday = ko.observable<boolean>();
    IllHourJs = ko.observable<string>();
    IllDay = ko.observable<number>();
    HolidayHourJs = ko.observable<string>();
    HolidayDay = ko.observable<number>();
    SpecialHolidayPaidHourJs = ko.observable<string>();
    SpecialHolidayPaidDay = ko.observable<number>();
    SpecialHolidayUnpaidHourJs = ko.observable<string>();
    SpecialHolidayUnpaidDay = ko.observable<number>();
    TimeOffHour = ko.observable<number>();
    TimeOffDay = ko.observable<number>();
    //Soll-Zeit in Minuten
    TargetHour = ko.observable<number>();
    PersonName = ko.observable<string>();
    ConfigurationItemId = ko.observable<string>();
    BeginJs = ko.observable<string>();
    EndJs = ko.observable<string>();
    Hours = ko.observable<number>();
    TotalTimeDetailsJs = ko.observable<string>("20000101000000");
    PersonNameTemp = ko.observable().extend({ dirty: ko.dirtyFlag() });
    ConfigurationItemIdTemp = ko.observable().extend({ dirty: ko.dirtyFlag() });
    SelectedPerson = ko.observable<any>();
    //computed
    TimeOffHourJs = ko.computed<string>(() => {
        if (this.TimeOffHour() != null) {
            var timeOffMoment = this.GetMomentOfMinutes(this.TimeOffHour());
            if (this.TimeOffHour() < 0) {
                return timeOffMoment.format("-HH:mm");
            }
            else {
                return timeOffMoment.format("HH:mm");
            }
        }
        return "";
    });
    TimeOffStyle = ko.computed<string>(() => {
        if (this.TimeOffDay() < 0) {
            return "#f2dede";
        }
        if (this.TimeOffDay() >= 0) {
            return "#dff0d8";
        }
    });
    DateStyle = ko.computed<string>(() => {
        if (this.IsPublicHoliday()) {
            return "#f2dede";
        }
        if (this.IsWeekend()) {
            return "#d9edf7";
        }
        return "#dff0d8";
    });
    TotalBreakJs = ko.computed<string>(() => {
        var totalBreak = moment("20000101000000", Bao.Utils.DateTimeFormat);
        var break1 = moment(this.Break1Js(), Bao.Utils.DateTimeFormat);
        var break2 = moment(this.Break2Js(), Bao.Utils.DateTimeFormat);
        var break3 = moment(this.Break3Js(), Bao.Utils.DateTimeFormat);
        if (break1 != null && break1.isValid()) {
            totalBreak = totalBreak.add(break1.hours(), "h");
            totalBreak = totalBreak.add(break1.minutes(), "m");
        }
        if (break2 != null && break2.isValid()) {
            totalBreak = totalBreak.add(break2.hours(), "h");
            totalBreak = totalBreak.add(break2.minutes(), "m");
        }
        if (break3 != null && break3.isValid()) {
            totalBreak = totalBreak.add(break3.hours(), "h");
            totalBreak = totalBreak.add(break3.minutes(), "m");
        }
        return totalBreak.format("20000101HHmm00");
    });
    TotalTimeJs = ko.computed<string>(() => {
        var totalTime = null;
        var totalTimeJs = "20000101000000";
        var beginDate = moment(this.BeginJs(), Bao.Utils.DateTimeFormat);
        var endDate = moment(this.EndJs(), Bao.Utils.DateTimeFormat);
        var totalBreak = moment(this.TotalBreakJs(), Bao.Utils.DateTimeFormat);
        var timeOffset = this.TargetHour();
        if (beginDate != null && beginDate.isValid() && endDate != null && endDate.isValid()) {
            if (beginDate.isBefore(endDate)) {
                var dif = endDate.diff(beginDate);
                var dur = moment.duration(dif);
                var minutesDur = dur.asMinutes();
                if (totalBreak != null && totalBreak.isValid()) {
                    minutesDur = minutesDur - totalBreak.hours() * 60 - totalBreak.minutes();
                }
                totalTime = this.GetMomentOfMinutes(minutesDur);
                totalTimeJs = totalTime.format("20000101HHmm00");
            }
        }
        this.CalculateTimeOff(totalTime);
        return totalTimeJs;
    });
    TotalTimeIsValid = ko.computed<boolean>(() => {
        if (this.TotalTimeJs() == this.TotalTimeDetailsJs()) {
            return true;
        }
        return false;
    });
    //functions
    CalculateDayToHour(day, hour) {
        if (!this._calculating && !this._initializing) {
            this._calculating = true;
            if (day() != null && this.TargetHour() != null) {
                var minutes = day() * this.TargetHour();
                var illHours = moment("20000101000000", Bao.Utils.DateTimeFormat);
                hour(illHours.add(minutes, "m").format("20000101HHmm00"));
            }
            else {
                hour(0);
            }
            this._calculating = false;
        }
    }
    ;
    CalculateHourToDay(day, hour) {
        if (!this._calculating && !this._initializing) {
            this._calculating = true;
            var tempHour = moment(hour(), Bao.Utils.DateTimeFormat);
            if (tempHour != null && this.TargetHour() != null && this.TargetHour() > 0) {
                day(((tempHour.hour() * 60) + tempHour.minute()) / this.TargetHour());
            }
            else {
                day(0);
            }
            this._calculating = false;
        }
    }
    ;
    CalculateTimeOff(totalTime) {
        if (!this._calculating && !this._initializing) {
            this._calculating = true;
            //Gesamtzeit berechnet ==> Zeitausgleich berechnen:                        
            var targetMinutes = this.TargetHour();
            if (targetMinutes == null) {
                targetMinutes = 0;
            }
            var timeOffset = targetMinutes * -1;
            if (totalTime != null) {
                var totalMinutes = totalTime.hours() * 60 + totalTime.minutes();
                timeOffset = totalMinutes - targetMinutes;
                //Urlaub und Krank noch addieren:
                timeOffset = timeOffset + this.GetMinutesOfJs(this.HolidayHourJs());
                timeOffset = timeOffset + this.GetMinutesOfJs(this.IllHourJs());
                timeOffset = timeOffset + this.GetMinutesOfJs(this.SpecialHolidayPaidHourJs());
                timeOffset = timeOffset + this.GetMinutesOfJs(this.SpecialHolidayUnpaidHourJs());
                this.TimeOffDay(timeOffset / this.TargetHour());
            }
            this.TimeOffHour(timeOffset);
            this._calculating = false;
        }
    }
    ;
    ChangeObject(step: number, configurationItemId: string) {
        if (this.TabPage.DirtyFlag() == true && this.SaveAllowed() === true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    if (this.CompleteCheck()) {
                        this.TabPage.IsLoading(true);
                        this.Save().done(() => {
                            this.SetDatePerson(step, configurationItemId);
                        });
                    }
                }
                else if (result === false) { //Nein
                    this.SetDatePerson(step, configurationItemId);
                }
                else { //Cancel
                    this.ConfigurationItemIdTemp(this.ConfigurationItemId());
                    this.PersonNameTemp(this.PersonName());
                }
            });
        }
        else {
            this.SetDatePerson(step, configurationItemId);
        }
    }
    ;
    SetDatePerson(step, configurationItemId: string) {
        var def = $.Deferred();
        this.TabPage.IsLoading(true);
        Bao.post("BookHours/GetByUserDateTime", JSON.stringify({
            personId: configurationItemId,
            date: this.DateJs(),
            step: step
        }), (value) => {
            //Neues Model ==> Mappen
            this.TabPage.DirtyFlag.pause();
            ko.map.fromJS(value, this, this.TabPage.DirtyFlag);
            //this.TabPage.ObjectId(this.OpenData());
            this.PerformRefresh();
            this.TabPage.DirtyFlag.reset();
            this.TabPage.IsLoading(false);
            def.resolve();
        });
        return def.promise();
    }
    ;
    GetMomentOfMinutes(minutes: number) {
        var m = moment("20000101000000", Bao.Utils.DateTimeFormat);
        if (minutes < 0) {
            m = m.add((minutes * -1), "m");
        }
        else {
            m = m.add(minutes, "m");
        }
        return m;
    }
    ;
    GetMinutesOfJs(js: string) {
        var minutes = 0;
        if (!Bao.Utils.String.IsNullOrEmpty(js)) {
            var m = moment(js, Bao.Utils.DateTimeFormat);
            minutes = m.minutes();
            minutes = minutes + m.hours() * 60;
        }
        return minutes;
    }
    ;
    GetMomentOfJs(js: string) {
        if (!Bao.Utils.String.IsNullOrEmpty(js)) {
            return moment(js, Bao.Utils.DateTimeFormat);
        }
        return null;
    }
    ;
    GetJsOfMinutes(minutes: number) {
        if (minutes != null) {
            var m = this.GetMomentOfMinutes(minutes);
            if (m != null) {
                return m.format("20000101HHmm00");
            }
        }
    }
    ;
    //CompleteCheck: Checks if the current object is valid and can be saved.
    //Returns true if Ok, else false
    CompleteCheck(): boolean {
        var isComplete = true;
        if (this.DateJs() == null) {
            isComplete = false;
        }
        if (this.ConfigurationItemId() == null) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    ;
    MinimizeEntity(): any {
        return ko.map.toJS(this, true);
    }
    ;
    Save(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post("BookHours/Save", JSON.stringify({ model: this.MinimizeEntity() }), (value) => {
            this.TabViewModel.SaveTabs(value.Result).then(() => {
                this.TabPage.DirtyFlag(false);
                this.PerformRefresh();
            });
        });
    }
    ;
    PerformRefresh(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        this._initializing = true;
        Bao.post("BookHours/Get", JSON.stringify({ id: this.ConfigurationItem100ActivityId() }), (value) => {
            this.TabPage.DirtyFlag.pause();
            //this.TabPage.ObjectId(value.ConfigurationItem100ActivityId);
            ko.map.fromJS(value, this);
            this.TabViewModel.RefreshTabs().then(() => {
                this._initializing = false;
                this.TabPage.IsLoading(false);
                this.TabPage.DirtyFlag.reset();
                def.resolve();
            });
        });
        return def.promise();
    }
    ;
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post("BookHours/Get", JSON.stringify({
            id: this.TabPage.UrlData().id
        }), (model) => {
            ko.map.fromJS(model, this, this.TabPage.DirtyFlag);
            this.TabPage.SessionTabId = this.SessionTabId();
            this.TabPage.IsLoading(false);
        });
    }
    ;
    loaded() {
        var tabPageBookHoursDetail = new TabPage();
        tabPageBookHoursDetail.AutoSelect = true;
        tabPageBookHoursDetail.Url("BookHours/BookHoursDetailTab");
        tabPageBookHoursDetail.Title = Bao.Session.GetMessage("msgBookHoursDetail");
        tabPageBookHoursDetail.IsClosable(false);
        tabPageBookHoursDetail.ViewModel(new BookHoursDetailViewModel(tabPageBookHoursDetail, this));
        tabPageBookHoursDetail.TabLoaded = () => {
            tabPageBookHoursDetail.ViewModel().loaded();
        };
        tabPageBookHoursDetail.ViewModel().TotalTimeJs.subscribe((value) => {
            this.TotalTimeDetailsJs(value);
        });
        this.TabViewModel.AddTab(tabPageBookHoursDetail);
        this._initializing = false;
    }
    ;
    //events
    HolidayClick = (value) => {
        if (!this._initializing) {
            this.HolidayDay(value);
        }
    };
    IllClick = (value) => {
        if (!this._initializing) {
            this._calculating = true;
            this.IllDay(value);
            this.IllHourJs(this.GetJsOfMinutes(this.TargetHour() * value));
            this._calculating = false;
            this.CalculateTimeOff(this.GetMomentOfJs(this.TotalTimeJs()));
        }
    };
    SpecialHolidayPaidClick = (value) => {
        if (!this._initializing) {
            this.SpecialHolidayPaidDay(value);
        }
    };
    SpecialHolidayUnpaidClick = (value) => {
        if (!this._initializing) {
            this.SpecialHolidayUnpaidDay(value);
        }
    };
    //DateBackward = () => {
    //    this.ChangeObject(-1, this.ConfigurationItemId());
    //};
    //DateForward = () => {
    //    this.ChangeObject(1, this.ConfigurationItemId());
    //};
    BindingDateTimeBoxDate: Bindings.baoDateTimeBox = {
        value: this.DateJs,
        mode: 'date',
        culture: ko.unwrap(Bao.Session.Language.Symbol)
    };
    BindingDateTimePickerDate: Bindings.baoDateTimePicker = {
        mode: 'date',
        showNavigation: true
    };
}
export default BookHoursViewModel;